import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ExportData_Convert } from "src/app/GlobalVariables";
import { ExportDataRequestDTO, ExportDataResponseDTO } from "./exportData.interface";

@Injectable({
    providedIn: 'root'
})
export class ExportDataService {
    private http = inject(HttpClient);

    ExportData_Convert(data: ExportDataRequestDTO): Observable<ExportDataResponseDTO> {
        return this.http.post<ExportDataResponseDTO>(ExportData_Convert, data);
    }
}
